module.exports = __webpack_public_path__ + "img/choice01.d5c7b487.png";